
import { useParams } from "react-router-dom";
import { ServiceHero } from "@/components/service/ServiceHero";
import { ServiceFeatures } from "@/components/service/ServiceFeatures";
import { ServiceProcess } from "@/components/service/ServiceProcess";
import { ServiceBenefits } from "@/components/service/ServiceBenefits";
import { ServiceCTA } from "@/components/service/ServiceCTA";
import { ServiceContactForm } from "@/components/service/ServiceContactForm";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";

const ServicePage = () => {
  const { serviceType: urlServiceType } = useParams();
  
  // Format service type for display (e.g., "hvac-repair" -> "HVAC Repair")
  const formattedServiceType = urlServiceType
    ?.split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ") || "Home Services";

  console.log('ServicePage rendering with:', {
    urlServiceType,
    formattedServiceType
  });

  const breadcrumbItems = [
    {
      label: "Services",
      href: "/services"
    },
    {
      label: formattedServiceType
    }
  ];

  // Mock data for service components based on the service type
  const mockFeatures = [
    {
      title: `Professional ${formattedServiceType}`,
      description: `Our vetted ${formattedServiceType} professionals deliver quality service with attention to detail.`
    },
    {
      title: "Licensed & Insured",
      description: "All service providers are fully licensed and insured for your peace of mind."
    },
    {
      title: "Transparent Pricing",
      description: "Get clear upfront quotes with no hidden fees or surprises."
    }
  ];

  const mockProcessSteps = [
    {
      title: "Request a Quote",
      description: `Fill out our simple form to get connected with top ${formattedServiceType} professionals.`
    },
    {
      title: "Get Matched",
      description: "We'll match you with pre-screened experts who specialize in your specific needs."
    },
    {
      title: "Compare Options",
      description: "Review quotes, credentials, and reviews to choose the best provider for your project."
    },
    {
      title: "Job Complete",
      description: "Your project gets done right, on time and within budget."
    }
  ];

  const mockBenefits = [
    {
      title: "Save Time",
      description: "No need to spend hours researching contractors - we've already done the vetting for you."
    },
    {
      title: "Quality Guaranteed",
      description: "We only work with the best professionals with proven track records of excellence."
    },
    {
      title: "Local Expertise",
      description: `Get connected with ${formattedServiceType} experts who understand Oklahoma City's unique needs.`
    },
    {
      title: "Ongoing Support",
      description: "Our team is here to help ensure your project goes smoothly from start to finish."
    }
  ];

  return (
    <div className="min-h-screen">
      <SEO
        title={`${formattedServiceType} Services in Oklahoma City`}
        description={`Find top-rated ${formattedServiceType} contractors in Oklahoma City. Get free quotes and connect with trusted professionals.`}
        canonicalUrl={`/services/${urlServiceType}`}
      />
      <div className="container px-4 py-8">
        <Breadcrumbs items={breadcrumbItems} />
      </div>
      <ServiceHero 
        title={`${formattedServiceType} Services`} 
        description={`Find the best ${formattedServiceType} professionals in Oklahoma City. Our network of trusted contractors provides exceptional service at competitive rates.`}
      />
      <ServiceFeatures features={mockFeatures} />
      <ServiceProcess steps={mockProcessSteps} />
      <ServiceBenefits benefits={mockBenefits} />
      <ServiceCTA 
        text={`Ready to get started with your ${formattedServiceType} project?`} 
        buttonText="Get Free Quotes" 
      />
      <ServiceContactForm 
        title={`Request ${formattedServiceType} Service`} 
        description="Fill out the form below and we'll connect you with top professionals in your area."
      />
    </div>
  );
};

export default ServicePage;
